import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Input, Spin, Space, Checkbox, Table, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, UploadOutlined, DeleteOutlined, DownloadOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message'; // 提示信息弹窗
import context from '../../public/js/context';
import { ContextHandler } from '../../public/js/contextHandler';
const { TextArea } = Input;
const { Option } = Select;

const SelectStudent = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [uploadFileList, setUploadFileList] = useState([]);
    const [checked, setChecked] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({"activeInd": "Y"});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [deptList, setDeptList] = useState([]);
    
    const tableColumns = {
        progCode: "prog_code",
        progLaunchYear: "prog_launch_year",
    }

    useEffect(() => {
        search(pageSize, 1, "N");
        form.setFieldsValue({});
        searchAllDept();
    }, []);

    //查询
    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("commonDropDown/searchAllDept").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }
    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.cohortYear = Config.cohort?.cohortYear;
        model.progCodeList = Config.userInfo?.progCodeList;
        setIsLoad(true);
        Base.callBackApi("studentModuleAdmin/searchStudent", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const removeFile = () => {
        setUploadFileList([]);
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({"activeInd": "Y"});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        // search(pageSize, 1, "reset")
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }
    const save = () => {
        if (!checkboxState[0] || checkboxState[0] === null) {
            errFrameShow("error", 'Please select a record.');
        } else {
            props.onClose(true, checkboxState[0]);
        }
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }
    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    const rowSelection = {
        type: 'radio',
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    };


    const columns = [
        {
            title: "Student ID",
            dataIndex: 'studentAcctId',
            className: 'tableWidth25',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: "Student Name",
            dataIndex: 'firstName',
            className: 'tableWidth25',
            render: (text, record) => text + ' ' + record.lastName
        },
        {
            title: "Email",
            dataIndex: 'email',
            className: 'tableWidth20',
        },
        {
            title: "Department",
            dataIndex: 'deptCode',
            className: 'tableWidth20',
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
    ];
    return (
        <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
            <Modal
                visible={true}//控制弹框是否显示
                title="Select Student"//标题
                centered//垂直居中
                destroyOnClose={true}//关闭即销毁？
                closable//是否显示右上角的关闭按钮
                maskClosable={false}//点击蒙层是否允许关闭	
                // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
                width={'1250px'}
                onCancel={() => onCancel(false)}//点击取消触发事件
                footer={[
                    <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>Select</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                <Message ref={messageRef} />
                <div className='sysSearchRow sysSearchBox'>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitle">Student ID</div>
                            <div className="sysSerchInput">
                                <Input type="text" placeholder="Student ID" value={searchModel.studentAcctId || ''}
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('studentAcctId', e.target.value)} />
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Student Name</div>
                            <div className="sysSerchInput">
                                <Input type="text" placeholder="Student Name" value={searchModel.studentName || ''}
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('progTitstudentNamele', e.target.value)} />
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Status</div>
                            <div className="sysSerchInput">
                                <Select className="sysSelect" placeholder="Status"
                                    value={searchModel.activeInd || ''}
                                    onChange={(e) => searchChange('activeInd', e)}
                                >
                                    <Option value=""></Option>
                                    {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div className='sysSearchButton'>
                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                    </div>
                </div>
                <div className="sysLineEight"></div>

                <div className="sysTable" id="tableOne">
                    <Table
                        rowSelection={rowSelection} //选择
                        scroll={{ x: 1000 }}
                        rowKey="studentId" //Key值
                        columns={columns} //列名
                        dataSource={tables} //数据
                        pagination={{  //分页
                            showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                            onChange: onChange,                        //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                            total: tablesCount,             //总共多少条数据
                            current: current,                //当前页
                            pageSize: pageSize,              //每页显示多少条数据
                            defaultCurrent: 1,                               //默认当前页为1
                            size: "small"
                        }}
                        onChange={handleTableChange}
                        onRow={(record) => {
                            return {
                                onClick: event => Base.selectRadioRowNew.call(this, record, 'studentId', selectedRowKeys, setCheckboxState, setSelectedRowKeys),
                            };
                        }}
                    />
                </div>

            </Modal>
        </Spin >
    )

}

SelectStudent.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default SelectStudent;